import { Controller } from "@hotwired/stimulus"
import { TempFormHelper } from "~/helpers/temp_form_helper"

export default class extends Controller {
  static get targets() {
    return ["email", "password", "smtpFrame", "smtpHost", "smtpPort", "smtpEncryption", "imapFrame", "imapHost", "imapPort"]
  }

  testSmtp({ params: { url } }) {
    TempFormHelper.create(url, "post", (form) => {
      TempFormHelper.addHiddenInput(form, "connection_type", "smtp")
      TempFormHelper.addHiddenInput(form, "smtp_imap_setup[email]", this.emailTarget.value)
      TempFormHelper.addHiddenInput(form, "smtp_imap_setup[smtp_host]", this.smtpHostTarget.value)
      TempFormHelper.addHiddenInput(form, "smtp_imap_setup[smtp_port]", this.smtpPortTarget.value)
      TempFormHelper.addHiddenInput(form, "smtp_imap_setup[smtp_encryption]", this.smtpEncryptionTarget.value)

      if (this.passwordTarget.value.length > 0) {
        TempFormHelper.addHiddenInput(form, "smtp_imap_setup[password]", this.passwordTarget.value)
      }
    }, this.smtpFrameTarget).requestSubmit()
  }

  testImap({ params: { url } }) {
    TempFormHelper.create(url, "post", (form) => {
      TempFormHelper.addHiddenInput(form, "connection_type", "imap")
      TempFormHelper.addHiddenInput(form, "smtp_imap_setup[email]", this.emailTarget.value)
      TempFormHelper.addHiddenInput(form, "smtp_imap_setup[imap_host]", this.imapHostTarget.value)
      TempFormHelper.addHiddenInput(form, "smtp_imap_setup[imap_port]", this.imapPortTarget.value)

      if (this.passwordTarget.value.length > 0) {
        TempFormHelper.addHiddenInput(form, "smtp_imap_setup[password]", this.passwordTarget.value)
      }
    }, this.imapFrameTarget).requestSubmit()
  }
}
